import { render } from "./BaseSwitch.vue?vue&type=template&id=2b07ed15&ts=true"
import script from "./BaseSwitch.vue?vue&type=script&lang=ts"
export * from "./BaseSwitch.vue?vue&type=script&lang=ts"

import "./BaseSwitch.vue?vue&type=style&index=0&id=2b07ed15&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__